import { createFileRoute } from "@tanstack/react-router";

import { ConceptsSearchPanel } from "@/features/search/concepts/concepts-search-panel";

export interface ConceptsSearchParams {
  ids?: string;
  q?: string;
}

export const Route = createFileRoute("/_authenticated/search/concepts")({
  validateSearch: (search: Record<string, unknown>): ConceptsSearchParams => ({
    ids: typeof search.ids === "string" ? search.ids : undefined,
    q: typeof search.q === "string" ? search.q : undefined,
  }),
  component: ConceptsSearchRoute,
});

function ConceptsSearchRoute() {
  const { ids, q } = Route.useSearch();
  return <ConceptsSearchPanel initialIds={ids ?? ""} initialQuery={q ?? ""} />;
}
